export const FORM_SUMMARY_CHARACTER_LIMIT_SM = 28;
export const FORM_SUMMARY_CHARACTER_LIMIT_LG = 40;
export const FORM_SUMMARY_CHANGE_OF_CIRCUMSTANCE = 'pending-changes-app';
export const FORM_SUMMARY_CHANGE_OF_CIRCUMSTANCE_EVENT = {
    name: FORM_SUMMARY_CHANGE_OF_CIRCUMSTANCE,
};
